export function setupAccordions () {
  const accoridanRoots = document.querySelectorAll('.uga-law-accordion')
  for (const accordianRoot of accoridanRoots) {
    setupAccordion(accordianRoot)
  }
}

function setupAccordion (rootElement) {
  console.log('Setup Accordian:', rootElement)
  const subsections = rootElement.querySelectorAll('.paragraph')
  for (const subsection of subsections) {
    setupSubsection(subsection)
  }
}

function setupSubsection (element) {
  const titleFieldElement = element.querySelector('.field--name-field_title')
  const bodyFieldElement = element.querySelector('.field--name-field_body')

  titleFieldElement.addEventListener('click', (event) => {
    bodyFieldElement.classList.toggle('expanded')
    if (bodyFieldElement.style.maxHeight) {
      bodyFieldElement.style.maxHeight = null
    } else {
      bodyFieldElement.style.maxHeight = `${bodyFieldElement.scrollHeight}px`
    }
  })

  console.log('SubSection', {
    titleFieldElement,
    bodyFieldElement
  })
}
